export default __webpack_public_path__ + "static/media/test3.84e5d1f4.png";